// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
module.exports = {
    "char": $foreign["char"],
    charAt: $foreign.charAt,
    charCodeAt: $foreign.charCodeAt
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.String.Unsafe/index.js
// module id = 331
// module chunks = 0